import ApiService from '@/services/api.service';

const actsService = {
    getContractActs: async payload => {
        try {
            const response = await ApiService.post('acts/getContractActs', payload);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getAccountActs: async payload => {
        try {
            const response = await ApiService.post('acts/getAccountsActs', payload);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getContractActsDetails: async payload => {
        try {
            const is_signed = payload.signed == 1 ? true : payload.signed == 0 ? false : null;
            const payloadData = {
                iWhereOrderLocale: {
                    where: [
                        { field: 'date_begin', value: payload.date_begin },
                        { field: 'date_end', value: payload.date_end },
                        { field: 'signed', value: is_signed }
                    ]
                }
            };
            const response = await ApiService.post('acts/getContractActsDetail', payloadData, {
                params: { object_contract_rid: payload.object_contract_rid }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getAccountActsDetails: async payload => {
        try {
            const is_signed = payload.signed == 1 ? true : payload.signed == 0 ? false : null;
            const payloadData = {
                iWhereOrderLocale: {
                    where: [
                        { field: 'date_begin', value: payload.date_begin },
                        { field: 'date_end', value: payload.date_end },
                        { field: 'signed', value: is_signed }
                    ]
                }
            };
            const response = await ApiService.post('acts/getAccountsActsDetail', payloadData, { params: { iaccount_rid: payload.account_rid } });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    deleteContractAct: async payload => {
        try {
            const response = await ApiService.delete(`acts/delObjectAct?act_rid=${payload}`);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    deleteAccountAct: async payload => {
        try {
            const response = await ApiService.delete(`acts/delAccountAct?act_rid=${payload}`);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    sendEmailContractAct: async payload => {
        try {
            const response = await ApiService.post('act_documents/sendContractActPDFToMail', payload);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    sendEmailAccountAct: async payload => {
        try {
            const response = await ApiService.post('act_documents/sendAccountActPDFToMail', payload);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    printPdfContractAct: async payload => {
        try {
            const response = await ApiService.post('act_documents/getContractsActPDF', payload, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    printPdfAccountAct: async payload => {
        try {
            const response = await ApiService.post('act_documents/getAccountActPDF', payload, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getInfoCreateAccountAct: async payload => {
        try {
            const response = await ApiService.get('acts/getAccountDataForAct', { params: { account_rid: payload }, showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getInfoCreateContractAct: async payload => {
        try {
            const response = await ApiService.get('acts/getContractDataForAct', { params: { obj_suppl_rid: payload }, showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    addAccountAct: async payload => {
        try {
            const response = await ApiService.post('acts/addAccountAct', payload, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    addContractAct: async payload => {
        try {
            const response = await ApiService.post('acts/addObjectAct', payload, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getContractsActPDF: async payload => {
        try {
            const response = await ApiService.post('act_documents/getContractsActPDF', payload);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getAccountActPDF: async payload => {
        try {
            const response = await ApiService.post('act_documents/getAccountActPDF', payload);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getContractActInfoToSign: async act_rid => {
        try {
            const response = await ApiService.get('act_documents/getContractActToSign', { params: { act_rid } });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getAccountActInfoToSign: async act_rid => {
        try {
            const response = await ApiService.get('act_documents/getAccountActToSign', { params: { act_rid } });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    postContractActSign: async paylaod => {
        try {
            const response = await ApiService.post('sign/postContractActSign', paylaod, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    postAccountActSign: async paylaod => {
        try {
            const response = await ApiService.post('sign/postAccountActSign', paylaod, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    }
};

export default actsService;
